/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCallback, useState } from "react";
import { useCurrentEditor } from "@tiptap/react";
import debounce from "lodash.debounce";
import { isGuid } from "utils/empty-exists";
import { Logger } from "cms/utils/log/logger";

const useUpdateDocument = () => {
    
    const markType = "doclink";
    const { editor } = useCurrentEditor();
    const doclink = editor.getAttributes(markType);
    const [selection,setSelection] = useState(editor?.view?.state?.selection);
    const [selectedText,setSelectedText] = useState(editor?.view?.state?.selection?.node?.text);
    
    const findSelection = debounce(() => {
        if (!editor) {
            return;
        }
        const { from, to, empty } = editor.state.selection;
        if (empty) {
            return;
        }
        const selectionText = editor.state.doc.textBetween(from, to, " ");
        Logger.debug(selectionText);
        setSelectedText(selectionText);
    }, 900);
    
    const updateDocLink = useCallback(
        (doclink) => {
            
            const guid = doclink?.guid;
            const title = doclink?.title;
            let replacementText = doclink?.link_text;
            const url = doclink?.url;
            
            if (isGuid(guid)) {
                
                editor.chain()
                    .focus()
                    .extendMarkRange(markType)
                    .unsetMark(markType)
                    .run();
                
                const _selection = editor?.view?.state?.selection;
                // eslint-disable-next-line no-unused-vars
                const [text, from ,to] = getSelectionText(editor);
                setSelection(_selection);
                setSelectedText(text);
                replacementText = replacementText ? replacementText : title;
                replacementText = replacementText.trim();
                
                const doclinkData = {
                    text: replacementText,
                    href: url,
                    url: url,
                    type: markType,
                    guid: guid,
                    target: "_blank",
                    rel: "noopener noreferrer nofollow",
                };
                replaceSelection(editor, doclinkData);
            }
        },
        [editor],
    );
    
    
    const getSelectionText = (editor) => {
        const selection = editor?.view?.state?.selection;
        const { $from, $to } = selection;
        const from = $from.pos;
        let to = $to.pos;
        let text = editor?.view?.state?.doc.textBetween(from, to, "");
        const lastChar = text[text.length-1];
        if (lastChar === " ") {
            to = $to.pos -1;
            text = editor?.view?.state?.doc.textBetween(from, to, "");
        }
        return [text, from, to];
    };
    const replaceSelection = (editor, markData) => {
        const replacementText = markData?.text;
        const transaction = editor.state.tr;
        const selection = editor?.view?.state?.selection;
        // eslint-disable-next-line no-unused-vars
        const { $from, $to } = selection;
        const from = $from.pos;
        // let to = $to.pos
        const replacementTo = from + replacementText.length;
        transaction.insertText(replacementText);
        const docLinkMark = editor.schema.marks.doclink.create(markData);
        transaction.addMark( from, replacementTo, docLinkMark );
        editor.view.dispatch(transaction);
    };
    
    return {
        doclink,
        updateDocLink,
        selection,
        selectedText,
        findSelection,
    };
};

export { useUpdateDocument };
